const normalizeUnknownExceptionToError = (e) => {
    try {
        return Error(JSON.stringify(e));
    }
    catch {
        // fallback in case there's an error when stringifying error
        return new Error(String(e));
    }
};
const getServerError = (error) => {
    if (error && 'response' in error && error.response?.status) {
        return error;
    }
};
export const matchServerError = (e) => {
    if (e instanceof Error) {
        const { response } = getServerError(e) ?? {};
        return {
            type: 'SERVER',
            status: response?.status,
            applicationErrorCode: response?.data?.details?.applicationError?.code,
            description: response?.data?.details?.description,
            baseError: e,
        };
    }
    const unknownError = normalizeUnknownExceptionToError(e);
    return {
        type: 'SERVER',
        status: undefined,
        description: undefined,
        applicationErrorCode: undefined,
        baseError: unknownError,
    };
};
//# sourceMappingURL=match-server-error.js.map